export default __webpack_public_path__ + "static/media/projectImg.771236e1.png";